import { useIdentity } from "@/context/identity-context";

export const usePermissions = () => {
  const { identity } = useIdentity();

  const permissions = identity?.userRole?.permissions || [];

  const hasPermission = (permission: string): boolean => {
    return permissions.includes(permission);
  };

  const hasAnyPermission = (permissionList: string[]): boolean => {
    return permissionList.some(permission => permissions.includes(permission));
  };

  const hasAllPermissions = (permissionList: string[]): boolean => {
    return permissionList.every(permission => permissions.includes(permission));
  };

  return {
    permissions,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    userRole: identity?.userRole,
    isAdmin: hasPermission("users") || hasPermission("users.without_dev"),
    isDeveloper: hasPermission("users"),
    isBranchOwner: hasPermission("dashboard.branch") && !hasPermission("dashboard"),
    isOperator: hasPermission("operator.branch") && permissions.length === 1,
  };
};